import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import NutshellFoundation from './icon-nutshell-foundation.svg';

function SvgComponent() {
    return <NutshellFoundation width={100} height={32} />;
}
SvgComponent.iconName = 'nutshellFoundation';

export const NutshellFoundationIcon = svgIconWrapper(SvgComponent);
